var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"[ c-hotel-details c-hotel-details--rooms ]"},[_c('h2',{staticClass:"[ u-margin-bottom-tiny ]"},[_vm._v(_vm._s(_vm._f("trans")('offer_card.room_details_headline')))]),_vm._l((_vm.rooms),function(room,index){return _c('HotelDetailRoom',{attrs:{"room":room,"index":index}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }